export default {
  TABLE_COLUMNS: [
    {
      key: 'orderId',
      displayName: 'Order ID',
      width: 1,
    },
    {
      key: 'transactionId',
      displayName: 'Transaction ID',
      width: 1,
    },
    {
      key: 'transactionAmount',
      displayName: 'Suspicious Amt.',
      width: 1.5,
      align: 'right',
    },
    {
      key: 'caseId',
      displayName: 'Case ID',
      width: 1,
    },
    // {
    //   key: 'settlementStatus',
    //   displayName: 'Settlement Status',
    //   width: 1,
    // },
    // {
    //   key: 'customerPhone',
    //   displayName: 'Phone No.',
    //   width: 0.14,
    // },
    // {
    //   key: 'paymentMode',
    //   displayName: 'Payment Method',
    //   width: 0.13,
    // },
    {
      key: 'riskStatus',
      displayName: 'Status',
      width: 1.6,
    },
    {
      key: 'suspiciousCta',
      displayName: '',
      width: 0.5,
    },
  ],
  FILTER_ITEMS: {},
  SEARCH_ITEMS: [],
};
